import { render } from "./AppWidgetLatestPosts.html?vue&type=template&id=fd023916"
import script from "./AppWidgetLatestPosts.js?vue&type=script&lang=js"
export * from "./AppWidgetLatestPosts.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__